import React from 'react';
import styles from './PageSizeSelect.module.css';

interface PageSizeSelectProps {
  value: number;
  options: readonly number[];
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PageSizeSelect: React.FC<PageSizeSelectProps> = ({ value, options, onChange }) => (
  <div className={styles.container}>
    <span>Mostrar</span>
    <select className={styles.select} value={value} onChange={onChange}>
      {options.map((opt) => (
        <option key={opt} value={opt}>{opt}</option>
      ))}
    </select>
  </div>
);

export default PageSizeSelect;
